import Yggdrasil from 'services/yggdrasil'

import { mapGetRibbons } from 'store/shared/courseHelper'

const state = {
    courses: [],
    collections: [],
    singleCollection: null
}

const mutations = {
    ASSIGN_RESTRICTED_DATA (state, { courses, collections }) {
        state.courses = courses
        state.collections = collections
    },
    CLEAR_AFTER_LOGOUT (state) {
        state.courses = []
        state.collections = []
    }
}

const actions = {
    async clearAfterLogout (store) {
        store.commit('CLEAR_AFTER_LOGOUT')
    },
    async loadData (store) {
        const data = await Yggdrasil.loadRestrictedData()
        store.commit('ASSIGN_RESTRICTED_DATA', data)
    }
}

const getters = {
    courses: (state) => state.courses,
    getCourseById: (state) => id => state.courses.find((course) => +course.id === +id),
    collections: (state) => state.collections,
    mapCourseToRibbon: (state) => mapGetRibbons,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
